/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, ElementRef, Renderer, HostBinding, ContentChild, ViewEncapsulation } from '@angular/core';
import classNames from 'classnames';

import { AddonAfter } from './addon.after';
import { AddonBefore } from './addon.before';
/**
 * 在输入框的前后加“拼接”组件<br>
 * 注意：
 * <span class="ant-input-group-addon"></span> 中间不能包含空格、换行等，否则:empty样式不起作用
 */
export class Addon {
/**
 * 样式前缀
 */
prefixCls = 'ant-input';
/**
 * 用户CSS样式
 */
class: string;

     addonBefore: AddonBefore;

     addonAfter: AddonAfter;
/**
 * @param {?} renderer
 * @param {?} elementRef
 */
constructor(private renderer: Renderer,
private elementRef: ElementRef) {

    }
/**
 * 样式
 * @return {?}
 */
get classes(): string {
        const /** @type {?} */ classes = classNames({
            [`${this.prefixCls}-group-wrapper`]: true,
        }, this.class);
        return classes;
    }
/**
 * 样式
 * @return {?}
 */
getWrapperClasses(): string {
        const /** @type {?} */ classes = classNames({
            [`${this.prefixCls}-wrapper`]: true,
            [`${this.prefixCls}-group`]: true
        });
        return classes;
    }
/**
 * @return {?}
 */
getAddonClass(): string {
        return `${this.prefixCls}-group-addon`;
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-addon',
    template: `
        <span [class]="getWrapperClasses()">
            <span [class]="getAddonClass()" *ngIf="addonBefore">
                <ng-content select="addon-before"></ng-content>
            </span>
            <ng-content></ng-content>
            <span [class]="getAddonClass()" *ngIf="addonAfter">
                <ng-content select="addon-after"></ng-content>
            </span>
        </span>
    `,
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'class': [{ type: Input },],
'addonBefore': [{ type: ContentChild, args: [AddonBefore, ] },],
'addonAfter': [{ type: ContentChild, args: [AddonAfter, ] },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function Addon_tsickle_Closure_declarations() {
/** @type {?} */
Addon.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Addon.ctorParameters;
/** @type {?} */
Addon.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
Addon.prototype.prefixCls;
/**
 * 用户CSS样式
 * @type {?}
 */
Addon.prototype.class;
/** @type {?} */
Addon.prototype.addonBefore;
/** @type {?} */
Addon.prototype.addonAfter;
/** @type {?} */
Addon.prototype.renderer;
/** @type {?} */
Addon.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
